<template>
    <div>
        <loading-spinner v-if="loading"></loading-spinner>
        <template v-else>
            <div class="container">
                <div class="new-details__header-container">
                    <gallery class="new-details__gallery-container" :pre-selected-paint-cap-id="vehicle.new_vehicles_trim.cap_paint_id" />
                    <div>
                        <div class="rd-card rd-card--border-top new-details__title-card" :class="{
                                'new-details__title-card--animate-in': animateIn,
                                'new-details__title-card-offer': hasOffer
                            }">
                            <div :class="{'new-details__title-card--inner-offer': hasOffer}">
                                <h1 class="new-details__title-h1">{{ modelTitle }}</h1>
                                <h2 class="new-details__title-h2">{{ vehicle.bodystyle }} {{ vehicle.version }}</h2>
                                <div class="pill-toggle pill-toggle--m-b pill-toggle--full-width new-details-pill-toggle--green" v-if="hasElectric">
                                    <div class="pill-toggle pill-toggle--full-width new-details-pill-toggle__inner-bg">
                                        <div class="pill-toggle__pill">
                                            <input class="pill-toggle__input new-details-pill-toggle__input" type="radio" v-model="electricSelected" :value="true" autocomplete="off" id="discoverElectric" />
                                            <label class="pill-toggle__label new-details-pill-toggle__label new-details-pill-toggle__label--electric" for="discoverElectric">Electric <img src="/images/new/details/electric-btn-icon.svg" alt="" class="new-details__has-electric-icon" /></label>
                                        </div>
                                        <div class="pill-toggle__pill">
                                            <input class="pill-toggle__input new-details-pill-toggle__input" type="radio" v-model="electricSelected" :value="false" autocomplete="off" id="viewAllEngines" />
                                            <label class="pill-toggle__label new-details-pill-toggle__label" for="viewAllEngines">All Engines</label>
                                        </div>
                                    </div>
                                </div>
                                <label class="new-details__select-model-title">Select engine size</label>
                                <div class="new-details__select-model-outer">
                                    <button @click="showSelectModel = !showSelectModel" type="button" class="btn btn--blue-inverted btn--full-width new-details__select-model-label">
                                        <span>{{ vehicle.version }}<img src="/images/new/details/green-electric-icon.svg" alt="" class="new-details__select-model-elec-icon" v-if="vehicle.electric"/></span>
                                        <img src="/images/new/details/down-arrow.svg" alt="" class="new-details__select-model-arrow" :class="{'new-details__select-model-arrow--selected': showSelectModel}" />
                                    </button>
                                    <div v-if="showSelectModel" class="new-details__select-model-container" ref="show-select-model" @focusout="showSelectModel = false">
                                        <button class="new-details__select-model-btn" :class="{'new-details__select-model-btn--electric': option.electric, 'new-details__select-model-btn--selected': option.id == vehicle.id}" @click="switchToModel(option)" v-for="option in filteredOptionsList" :key="'selectModel.' + option.id">{{ option.version }}<img src="/images/new/details/green-electric-icon.svg" alt="" class="new-details__select-model-elec-icon" v-if="option.electric"/></button>
                                    </div>
                                </div>
                                <div class="new-details__pricing-container">
                                    <div class="new-details__pricing-area new-details__pricing-area--cash-price">
                                        <label class="new-details__pricing-label">Cash Price</label>
                                        <p class="new-details__pricing-value">£{{ NumberFormat(vehicle.pricing_display_price, 0) }}</p>
                                    </div>
                                    <div class="new-details__pricing-area new-details__pricing-area--saving">
                                        <template v-if="selectedFinance == 'pch' && vehicle.have_pch == 1 && vehicle.pch_saving > 0">
                                            <label class="new-details__pricing-label">Customer Saving</label>
                                            <p class="new-details__pricing-value">£{{ NumberFormat(vehicle.pch_saving, 0) }}</p>
                                        </template>
                                        <template v-else-if="selectedFinance != 'pch' && vehicle.pricing_display_savings > 0 && showCustomerSaving">
                                            <label class="new-details__pricing-label">Customer Saving</label>
                                            <p class="new-details__pricing-value">£{{ NumberFormat(vehicle.pricing_display_savings, 0) }}</p>
                                        </template>
                                    </div>
                                    <div class="new-details__pricing-area new-details__pricing-area--monthly" v-if="selectedFinance == 'pch' && vehicle.have_pch == 1" @click="scrollToFinance">
                                        <label class="new-details__pricing-label">Monthly Price</label>
                                        <p class="new-details__pricing-value new-details__pricing-value--finance">£{{ NumberFormat(vehicle.pch_monthly_payment, 0) }}</p>
                                    </div>
                                    <template v-else>
                                        <div class="new-details__pricing-area new-details__pricing-area--monthly" v-if="financeAvailable && (financeLoading || quoteWithPredictableKeys.monthly > 0)" @click="scrollToFinance">
                                            <label class="new-details__pricing-label">Monthly Price</label>
                                            <loading-spinner class="new-details__pricing-loader" v-if="financeLoading" />
                                            <p v-else class="new-details__pricing-value new-details__pricing-value--finance">£{{ NumberFormat(quoteWithPredictableKeys.monthly, 0) }}</p>
                                        </div>
                                        <template v-if="!financeLoading && financeAvailable">
                                            <div class="new-details__pricing-area new-details__pricing-area--depcon" v-if="vehicle.brand == 'peugeot' && quoteWithPredictableKeys.dealerDepCon > 0 && quoteWithPredictableKeys.depConExcludingDealer > 0" @click="scrollToFinance">
                                                <label class="new-details__pricing-label">{{ depConName }}</label>
                                                <p class="new-details__pricing-value new-details__pricing-value--finance">£{{ NumberFormat(quoteWithPredictableKeys.depConExcludingDealer, 0) }}</p>
                                            </div>
                                            <div class="new-details__pricing-area new-details__pricing-area--depcon" v-else-if="(vehicle.brand == 'peugeot' && quoteWithPredictableKeys.dealerDepCon <= 0 && quoteWithPredictableKeys.depCon > 0) || (vehicle.brand != 'peugeot' && quoteWithPredictableKeys.depCon > 0)" @click="scrollToFinance">
                                                <label class="new-details__pricing-label">{{ depConName }}</label>
                                                <p class="new-details__pricing-value new-details__pricing-value--finance">£{{ NumberFormat(quoteWithPredictableKeys.depCon, 0) }}</p>
                                            </div>
                                            <div class="new-details__pricing-area new-details__pricing-area--apr" v-if="quoteWithPredictableKeys.monthly > 0" @click="scrollToFinance">
                                                <label class="new-details__pricing-label">APR Rate</label>
                                                <p v-if="financeModified" class="new-details__pricing-value new-details__pricing-value--finance">{{ quoteWithPredictableKeys.apr }}% APR</p>
                                                <p v-else class="new-details__pricing-value new-details__pricing-value--finance">{{ quoteWithPredictableKeys.apr }}% APR Representative</p>
                                            </div>
                                            <div class="new-details__pricing-area new-details__pricing-area--depcon" v-if="vehicle.brand == 'peugeot' && quoteWithPredictableKeys.dealerDepCon > 0" @click="scrollToFinance">
                                                <label class="new-details__pricing-label">Part Exchange Boost*</label>
                                                <p class="new-details__pricing-value new-details__pricing-value--finance">£{{ NumberFormat(quoteWithPredictableKeys.dealerDepCon, 0) }}</p>
                                            </div>
                                        </template>
                                    </template>
                                </div>
                                <div class="new-details__ctas">
                                    <button type="button" v-show="financeAvailable" @click="scrollToFinance" class="link link--has-icon link--is-button link--secondary">Personalise finance</button>
                                    <button type="button" class="btn btn--primary btn--full-width" @click="scrollToEnquireNow">Enquire Now</button>
                                    <button type="button" class="btn btn--primary-inverted btn--full-width" @click="scrollToTestDrive">Book a Test Drive</button>
                                    <button v-if="haveNewVehiclesInStock" type="button" class="link link--has-icon link--is-button link--secondary" @click="scrollToNewVehiclesInStock">View Vehicles In Stock</button>
                                    <button type="button" @click="scrollToValuation" class="link link--has-icon link--is-button">Value My Car</button>
                                </div>
                            </div>
                        </div>
                        <div v-if="showAlfaHomeChargerOffer" class="new-details__home-charger-offer">
                            Including Complimentary Wallbox & Installation*
                        </div>
                        <div v-else-if="showElectricVehicleGrant" class="new-details__home-charger-offer">
                            Now Including £1,500 {{ manufacturerName }} Electric Vehicle Grant
                        </div>
                    </div>
                </div>
            </div>

            <div class="bg bg--light-blue">
                <div class="container">
                    <h2 class="new-details__h2">Key Specification</h2>
                    <div class="new-details__key-specs">
                        <div class="new-details__key-spec-item">
                            <img class="new-details__key-spec-icon" src="/images/new/details/powertrain-electric-icon.svg" alt="Fuel Type" />
                            <span class="new-details__key-spec-label">Fuel type:</span>
                            <span class="new-details__key-spec-value">{{ vehicle.fuel_type }}</span>
                        </div>
                        <div class="new-details__key-spec-item" v-if="vehicle.max_ev_range > 0">
                            <img class="new-details__key-spec-icon" src="/images/new/details/range-icon.svg" alt="Max Range" />
                            <span class="new-details__key-spec-label">Max range:</span>
                            <span class="new-details__key-spec-value">{{ NumberFormat(vehicle.max_ev_range, 0) }} miles</span>
                        </div>
                        <div class="new-details__key-spec-item">
                            <img class="new-details__key-spec-icon" src="/images/new/details/transmission-icon.svg" alt="Transmission" />
                            <span class="new-details__key-spec-label">Transmission:</span>
                            <span class="new-details__key-spec-value">{{ vehicle.transmission }}</span>
                        </div>
                        <div class="new-details__key-spec-item">
                            <img class="new-details__key-spec-icon" src="/images/new/details/bodystyle-icon.svg" alt="Body style" />
                            <span class="new-details__key-spec-label">Body style:</span>
                            <span class="new-details__key-spec-value">{{ vehicle.friendly_bodystyle }}</span>
                        </div>
                        <div class="new-details__key-spec-item" v-if="maxChargeTime" :title="maxChargeTimeMessage">
                            <img class="new-details__key-spec-icon" src="/images/new/details/max-charge-time.svg" alt="Max charge time" />
                            <span class="new-details__key-spec-label">Max charge time:</span>
                            <span class="new-details__key-spec-value">{{ niceMaxChargeTime }}</span>
                        </div>
                        <div class="new-details__key-spec-item" v-if="quickChargeTime" :title="quickChargeTimeMessage">
                            <img class="new-details__key-spec-icon" src="/images/new/details/quick-charge-time.svg" alt="Quick charge time" />
                            <span class="new-details__key-spec-label">Quick charge time:</span>
                            <span class="new-details__key-spec-value">{{ niceQuickChargeTime }}</span>
                        </div>
                        <div class="new-details__key-spec-item">
                            <img class="new-details__key-spec-icon" src="/images/new/details/seats.svg" alt="Seats" />
                            <span class="new-details__key-spec-label">Seats:</span>
                            <span class="new-details__key-spec-value">{{ vehicle.seats }}</span>
                        </div>
                        <div class="new-details__key-spec-item" v-if="vehicle.insurance_scale">
                            <img class="new-details__key-spec-icon" src="/images/new/details/insurance.svg" alt="Insurance" />
                            <span class="new-details__key-spec-label">Insurance:</span>
                            <span class="new-details__key-spec-value">{{ vehicle.insurance_scale }}</span>
                        </div>
                        <div class="new-details__key-spec-item" v-if="vehicle.co2 > 0">
                            <img class="new-details__key-spec-icon" src="/images/new/details/co2.svg" alt="CO2 Emissions" />
                            <span class="new-details__key-spec-label">CO2:</span>
                            <span class="new-details__key-spec-value">{{ NumberFormat(vehicle.co2, 0) }} g/km</span>
                        </div>
                        <div class="new-details__key-spec-item" v-if="vehicle.engine_size > 1">
                            <img class="new-details__key-spec-icon" src="/images/new/details/engine.svg" alt="Engine capacity" />
                            <span class="new-details__key-spec-label">Engine size:</span>
                            <span class="new-details__key-spec-value">{{ NumberFormat(vehicle.engine_size, 0) }} CC</span>
                        </div>
                        <div class="new-details__key-spec-item" v-if="luggageCapacity" :title="luggageCapacity.name">
                            <img class="new-details__key-spec-icon" src="/images/new/details/luggage.svg" alt="Luggage capacity" />
                            <span class="new-details__key-spec-label">Luggage capacity:</span>
                            <span class="new-details__key-spec-value">{{ NumberFormat(luggageCapacity.value, 0) }} L</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bg" v-if="standardSpec || techSpecs">
                <div class="container">
                    <h2 id="full-spec" class="new-details__h2">Full Vehicle Specification</h2>
                    <h3 class="new-details__full-spec-h3">For {{ vehicle.vehicle_title }}</h3>
                    <div class="new-details__swiper-container">
                        <div class="new-details__swiper-btn new-details__swiper-prev" ref="swiper-prev"></div>
                        <div class="swiper new-details__swiper" ref="specButtons">
                            <div class="swiper-wrapper configurator__buttons-wrapper">
                                <button v-for="(spec, label) in standardSpec" :key="label" type="button" class="swiper-slide btn btn--blue-inverted new-details__spec-btn" :class="{'new-details__spec-btn--selected': standardSpecSelected == label}" @click="standardSpecSelected = label">{{ label }}</button>
                                <button type="button" class="swiper-slide btn btn--blue-inverted new-details__spec-btn" :class="{'new-details__spec-btn--selected': standardSpecSelected == 'General'}" @click="standardSpecSelected = 'General'">General</button>
                            </div>
                        </div>
                        <div class="new-details__swiper-btn new-details__swiper-next" ref="swiper-next"></div>
                    </div>
                    <div class="new-details__full-spec-values-container">
                        <div v-for="(spec, label) in standardSpec" v-show="standardSpecSelected == label && label != 'Options'" :key="label + '.items'" class="new-details__spec-item-container">
                            <div v-for="(item, index) in spec" class="new-details__spec-item new-details__spec-item-value" :key="label + '.' + index + '.item'" v-html="item"></div>
                        </div>
                        <optional-extras v-show="standardSpecSelected == 'Options'"></optional-extras>
                        <tech-specs v-show="standardSpecSelected == 'General'"></tech-specs>
                    </div>
                </div>
            </div>
            <div class="bg" v-show="financeAvailable" ref="finance-calculator">
                <div id="personaliseFinance" class="container">
                    <finance-calculator @apply-for-finance="applyForFinance" @apply-for-pch="applyForPCH" @scroll-to-valuation="scrollToValuation" :show-electric-vehicle-grant="showElectricVehicleGrant"></finance-calculator>
                </div>
            </div>

            <div class="bg" ref="enquire-now">
                <div class="container">
                    <enquire-now class="rd-card rd-card--border-top" :should-attach-finance="shouldAttachFinance" :should-attach-pch="shouldAttachPCH" @scroll-to-valuation="scrollToValuation"></enquire-now>
                </div>
            </div>

            <div class="bg" ref="valuation">
                <div class="container">
                    <valuation-tool :new-vehicle-id="vehicle.id" />
                </div>
            </div>

            <div class="bg" ref="stock" v-if="haveNewVehiclesInStock">
                <new-cars-in-stock class="container" />
            </div>

            <benefits />

            <div class="bg" ref="test-drive">
                <div class="container">
                    <test-drive @scroll-to-valuation="scrollToValuation" />
                </div>
            </div>

            <div class="bg" v-if="showAlfaHomeChargerOffer">
                <div class="container">
                    <p>*<strong>Complimentary Octopus EV home charger installation:</strong> Choice of Ohme ePOD or Home Pro (tethered) EV home charger with standard installation up to the value of £999 inc. VAT. The offer is fulfilled by Octopus Energy for installation at residential properties only. Available with new car retail orders from 6th January to 31st March 2025. It is the customer’s responsibility to ensure all required third party permissions are sought in relation to the installation of the wall box at their address. Non-standard installation of EV home charge may incur additional costs, which are paid directly by the customer to Octopus. Residents of Northern Ireland, Channel Islands and Isle of Man will receive a £999 inc. VAT contribution directly from their Retailer. We reserve the right to amend, suspend or withdraw this promotion at any time. <strong>There is no cash alternative to the promotion, and it is non-transferable.</strong> Information correct at time of going to publication.</p>
                </div>
            </div>

            <div class="cms-content-get-in-touch bg bg--rd-stellantis-pop-blue">
                <div class="container">
                    <div class="cms-content-get-in-touch__headings">
                        <p class="cms-content-get-in-touch__heading">Get in touch</p>
                        <p>We are available Mon - Fri: 8am - 7pm, Sat 8am - 5:30pm and Sun: 10am - 5pm</p>
                    </div>
                    <div class="cms-content-get-in-touch__sections" id="cms-content-get-in-touch-{!! $CMSContentSlice->id !!}">
                        <a href="#live-chat" @click.prevent="openLiveChat" class="cms-content-get-in-touch__section">
                            <svg class="cms-content-get-in-touch__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86.5 86.5">
                                <g fill="none" fill-rule="evenodd" transform="translate(.3 .3)">
                                    <path fill="#FFF" fill-rule="nonzero"
                                        d="M61.9 24H34.2a8 8 0 0 0-8 8v22.8l-3.9 3.4V31.7c0-6.3 5.3-11.4 11.6-11.4h22a6 6 0 0 1 3.4 1.1c.5.4 1.2.3 1.6-.2.4-.5.3-1.3-.2-1.6a8 8 0 0 0-4.8-1.6h-22C26.3 18 20 24.1 20 31.7v29.1c0 .5.3.9.7 1 .5.3 1 .2 1.3-.1l4.1-3.7v8.8a1.2 1.2 0 0 0 2 .9l6.8-6.2.6-.5.7-.6h25.7c4.5 0 8.1-3.7 8.1-8.1V32a8 8 0 0 0-8.1-8Zm5.8 28.3c0 3.1-2.6 5.7-5.8 5.7H37.2c-1.8 0-2 0-3.3 1.3l-.6.5-4.8 4.4V32c0-3.1 2.5-5.7 5.7-5.7H62c3.2 0 5.8 2.6 5.8 5.7v20.3Z" />
                                    <circle cx="43" cy="43" r="43" stroke="#FFF" stroke-width=".5" opacity=".6" />
                                </g>
                            </svg>

                            <div>
                                <p class="cms-content-get-in-touch__content-heading">Live Chat</p>
                                <p class="cms-content-get-in-touch__content-text">Start a conversation</p>
                            </div>
                        </a>
                        <a href="tel:02476851406" class="cms-content-get-in-touch__section">
                            <img src="/images/new/details/phone.svg" class="cms-content-get-in-touch__icon" alt="" />
                            <div>
                                <p class="cms-content-get-in-touch__content-heading">Call Us</p>
                                <p class="cms-content-get-in-touch__content-text">024 7685 1406</p>
                            </div>
                        </a>
                        <a :href="'/dealer-locator?brand=' + vehicle.brand" class="cms-content-get-in-touch__section">
                            <img src="/images/new/details/contact-us.svg" class="cms-content-get-in-touch__icon" alt="" />
                            <div>
                                <p class="cms-content-get-in-touch__content-heading">Contact Us</p>
                                <p class="cms-content-get-in-touch__content-text">Find your local dealership</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import Swiper, {Navigation} from "swiper";
import LoadingSpinner from '../../core/components/LoadingSpinner.vue';
import Gallery from '../components/details/Gallery.vue';
import TechSpecs from '../components/details/TechSpecs.vue';
import OptionalExtras from '../components/details/OptionalExtras.vue';
import FinanceCalculator from '../components/details/FinanceCalculator.vue';
import EnquireNow from '../components/details/EnquireNow.vue';
import TestDrive from '../components/details/TestDrive.vue';
import Benefits from '../components/details/Benefits.vue';
import NewCarsInStock from '../components/details/NewCarsInStock.vue';
import ValuationTool from '../../valuation-tool/ValuationTool.vue';
import { mapState } from 'vuex';
import NumberFormat from "../../used-vue/api/NumberFormat";
import { trackPageView } from "../../modules/tracking/AnalyticsEvents";
import scrollToElement from "../../configurator/modules/scrollToElement";
import GetManufacturerFromBrand from "../../used-vue/api/GetManufacturerFromBrand";

export default {
    components: {
        LoadingSpinner,
        Gallery,
        TechSpecs,
        OptionalExtras,
        FinanceCalculator,
        ValuationTool,
        NewCarsInStock,
        EnquireNow,
        TestDrive,
        Benefits
    },
    props: {
        id: {
            required: true,
        },
        brand: {
            required: true,
        },
    },
    data() {
        return {
            firstLoad: true,
            preventElectricSelectedSwitchOnFirstLoad: false,
            loading: true,
            showSelectModel: false,
            standardSpecSelected: null,
            electricSelected: false,
            shouldAttachFinance: false,
            shouldAttachPCH: false,
            animationTimeout: null,
            animateIn: false,
        };
    },
    created() {
        if (typeof window.brand == 'undefined' || window.brand != this.brand) {
            window.brand = this.brand;
        }
    },
    methods: {
        NumberFormat,
        switchToModel(modelToSwitchTo) {
            if (this.id == modelToSwitchTo.id) {
                return;
            }
            this.$router.push({ name: 'new-details', params: {brand: this.vehicle.brand, id: modelToSwitchTo.id, slug: modelToSwitchTo.slug}});
        },
        scrollToEnquireNow() {
            VueScrollTo.scrollTo(this.$refs["enquire-now"], 500);
        },
        scrollToTestDrive() {
            VueScrollTo.scrollTo(this.$refs["test-drive"], 500);
        },
        scrollToValuation() {
            VueScrollTo.scrollTo(this.$refs["valuation"], 500);
        },
        scrollToFinance() {
            VueScrollTo.scrollTo(this.$refs["finance-calculator"], 500);
        },
        scrollToNewVehiclesInStock() {
            VueScrollTo.scrollTo(this.$refs["stock"], 500);
        },
        applyForFinance() {
            this.shouldAttachFinance = true;
            this.shouldAttachPCH = false;
            VueScrollTo.scrollTo(this.$refs["enquire-now"], 500);
        },
        applyForPCH() {
            this.shouldAttachFinance = false;
            this.shouldAttachPCH = true;
            VueScrollTo.scrollTo(this.$refs["enquire-now"], 500);
        },
        openLiveChat() {
            window.liveChatClass.openLiveChat();
        }
    },
    computed: {
        ...mapState('NewVehicleData', ['vehicle', 'standardSpec', 'availableOptions', 'techSpecs', 'newVehiclesInStock']),
        ...mapState('Finance', ['financeAvailable', 'financeLoading', 'financeModified', 'quoteWithPredictableKeys', 'selectedFinance', 'selectedTerm', 'selectedDeposit', 'cashPriceForced']),
        showCustomerSaving() {
            // Hide 0% APR offer customer saving for Peugeot https://3.basecamp.com/3571161/buckets/10782166/todos/8868992991#__recording_8886567843
            if (this.cashPriceForced) {
                return false;
            }
            // Hard coded E-3008 https://3.basecamp.com/3571161/buckets/10782166/todos/7677924357
            if (this.vehicle.titre_code != '1PPDSYTEUFT0A0B0') {
                return true;
            }
            if (this.selectedTerm != 37) {
                return true;
            }
            if (this.selectedDeposit < 15100) {
                return true;
            }
            return false;
        },
        haveNewVehiclesInStock() {
            return this.newVehiclesInStock.length > 0;
        },
        modelTitle() {
            if (this.vehicle.fuel_type != 'Electric') {
                return this.vehicle.new_model.model_title;
            }
            if (this.vehicle.new_model.electric_model_title) {
                return this.vehicle.new_model.electric_model_title;
            }

            return this.vehicle.new_model.model_title;
        },
        availableOptionsLength() {
            return this.availableOptions.length;
        },
        //
        weightAndCapacitiesData() {
            if (!this.techSpecs) {
                return false;
            }
            if (typeof this.techSpecs['Weight and Capacities'] == 'undefined') {
                return false;
            }
            return this.techSpecs['Weight and Capacities'];
        },
        luggageCapacity() {
            if (this.weightAndCapacitiesData === false) {
                return false;
            }

            let biggestLuggageCapacity = false;

            this.weightAndCapacitiesData.forEach(item => {
                if (String(item.name).indexOf('Luggage Capacity') == -1) {
                    return;
                }
                if (biggestLuggageCapacity === false || parseInt(item.value) > parseInt(biggestLuggageCapacity.value)) {
                    biggestLuggageCapacity = item;
                }
            });

            return biggestLuggageCapacity;
        },
        electricVehicleData() {
            if (this.vehicle.fuel_type != 'Electric') {
                return false;
            }
            if (!this.techSpecs) {
                return false;
            }
            if (typeof this.techSpecs['Electric Vehicle Data'] == 'undefined') {
                return false;
            }
            return this.techSpecs['Electric Vehicle Data'];
        },
        maxChargeTime() {
            if (this.electricVehicleData === false) {
                return false;
            }

            let longestChargeTime = false;
            this.electricVehicleData.forEach(item => {
                if (String(item.name).substring(0, 26) != 'Battery Charging Scenario ') {
                    return;
                }
                if (String(item.name).indexOf('Charge Time (Mins)') == -1) {
                    return;
                }
                if (longestChargeTime === false || parseInt(item.value) > parseInt(longestChargeTime.value)) {
                    longestChargeTime = item;
                }
            });

            if (longestChargeTime === false) {
                return false;
            }

            const getScernarioNumberRegex = /Battery Charging Scenario (\d+) .*/i;
            const matches = longestChargeTime.name.match(getScernarioNumberRegex);
            if (matches === null) {
                return false;
            }
            if (typeof matches[1] == 'undefined') {
                return false;
            }
            const scenarioNumber = parseInt(matches[1]);

            const maxChargeTimeData = {
                duration: longestChargeTime.value,
                powerSupply: null,
                percent: null,
            };
            this.electricVehicleData.forEach(item => {
                const getScernarioNumberRegex = /Battery Charging Scenario (\d+) .*/i;
                const matches = item.name.match(getScernarioNumberRegex);
                if (matches === null || typeof matches[1] == 'undefined' || parseInt(matches[1]) != scenarioNumber) {
                    return;
                }
                if (String(item.name).indexOf('Percentage Change') >= 0) {
                    maxChargeTimeData.percent = item.value;
                    return;
                }
                if (String(item.name).indexOf('Power Supply - kW') >= 0) {
                    maxChargeTimeData.powerSupply = item.value;
                    return;
                }
            });

            return maxChargeTimeData;
        },
        niceMaxChargeTime() {
            if (!this.maxChargeTime) {
                return false;
            }
            const duration = parseInt(this.maxChargeTime.duration);
            if (duration > 60) {
                const hours = Math.floor(duration / 60);
                const minutes = duration - (hours * 60);
                if (minutes > 0) {
                    return hours + ' hours, ' + minutes + 'mins';
                }
                return hours + ' hours';
            }
            return duration + ' mins';
        },
        maxChargeTimeMessage() {
            if (!this.maxChargeTime) {
                return false;
            }
            if (this.maxChargeTime.powerSupply !== null && this.maxChargeTime.percent !== null) {
                return 'Based on a ' + this.maxChargeTime.powerSupply + 'kW power supply, charging from ' + this.maxChargeTime.percent + '%';
            }
            if (this.maxChargeTime.percent !== null) {
                return 'Based on a ' + this.maxChargeTime.powerSupply + 'kW power supply';
            }
            if (this.maxChargeTime.powerSupply !== null) {
                return 'Based on charging from ' + this.maxChargeTime.percent + '%';
            }
            return false;
        },
        quickChargeTime() {
            if (this.electricVehicleData === false) {
                return false;
            }

            let shortestChargeTime = false;
            this.electricVehicleData.forEach(item => {
                if (String(item.name).substring(0, 26) != 'Battery Charging Scenario ') {
                    return;
                }
                if (String(item.name).indexOf('Charge Time (Mins)') == -1) {
                    return;
                }
                if (shortestChargeTime === false || parseInt(item.value) < parseInt(shortestChargeTime.value)) {
                    shortestChargeTime = item;
                }
            });

            if (shortestChargeTime === false) {
                return false;
            }

            const getScernarioNumberRegex = /Battery Charging Scenario (\d+) .*/i;
            const matches = shortestChargeTime.name.match(getScernarioNumberRegex);
            if (matches === null) {
                return false;
            }
            if (typeof matches[1] == 'undefined') {
                return false;
            }
            const scenarioNumber = parseInt(matches[1]);

            const maxChargeTimeData = {
                duration: shortestChargeTime.value,
                powerSupply: null,
                percent: null,
            };
            this.electricVehicleData.forEach(item => {
                const getScernarioNumberRegex = /Battery Charging Scenario (\d+) .*/i;
                const matches = item.name.match(getScernarioNumberRegex);
                if (matches === null || typeof matches[1] == 'undefined' || parseInt(matches[1]) != scenarioNumber) {
                    return;
                }
                if (String(item.name).indexOf('Percentage Change') >= 0) {
                    maxChargeTimeData.percent = item.value;
                    return;
                }
                if (String(item.name).indexOf('Power Supply - kW') >= 0) {
                    maxChargeTimeData.powerSupply = item.value;
                    return;
                }
            });

            return maxChargeTimeData;
        },
        niceQuickChargeTime() {
            if (!this.quickChargeTime) {
                return false;
            }
            const duration = parseInt(this.quickChargeTime.duration);
            if (duration > 60) {
                const hours = Math.floor(duration / 60);
                const minutes = duration - (hours * 60);
                if (minutes > 0) {
                    return hours + ' hours, ' + minutes + 'mins';
                }
                return hours + ' hours';
            }
            return duration + ' mins';
        },
        quickChargeTimeMessage() {
            if (!this.quickChargeTime) {
                return false;
            }
            if (this.quickChargeTime.powerSupply !== null && this.quickChargeTime.percent !== null) {
                return 'Based on a ' + this.quickChargeTime.powerSupply + 'kW power supply, charging from ' + this.quickChargeTime.percent + '%';
            }
            if (this.quickChargeTime.percent !== null) {
                return 'Based on a ' + this.quickChargeTime.powerSupply + 'kW power supply';
            }
            if (this.quickChargeTime.powerSupply !== null) {
                return 'Based on charging from ' + this.quickChargeTime.percent + '%';
            }
            return false;
        },
        hasElectric() {
            let hasElectric = false;
            let hasOther = false;
            for (let index = 0; index < this.availableOptionsLength; index++) {
                if (this.availableOptions[index].electric) {
                    hasElectric = true;
                    continue;
                }
                hasOther = true;
            }
            return (hasElectric && hasOther);
        },
        filteredOptionsList() {
            if (this.electricSelected == false) {
                return this.availableOptions;
            }
            const filteredOptions = [];
            for (let index = 0; index < this.availableOptionsLength; index++) {
                if (this.availableOptions[index].electric) {
                    filteredOptions.push(this.availableOptions[index]);
                }
            }
            return filteredOptions;
        },
        depConName() {
            if (this.vehicle.fuel_type == 'Electric') {
                if (this.quoteWithPredictableKeys.depCon != 3000) {
                    return 'Deposit Contribution';
                }
                if (this.vehicle.brand == 'fiat') {
                    return 'Fiat e-Grant';
                }
                if (this.vehicle.brand == 'abarth') {
                    return 'Abarth e-Grant';
                }
                return 'Deposit Contribution';
            }
            return 'Deposit Contribution';
        },
        hasOffer(){
            if(this.hasPaintOffer || this.hasServiceOffer){
                return true;
            }
            return false;
        },
        hasPaintOffer(){
            const brands = ['ds', 'jeep', 'vauxhall']
            return brands.includes( this.vehicle.brand)
        },
        hasServiceOffer(){
            const brands = ['peugeot', 'citroen', 'fiat', 'abarth', 'alfa-romeo']
            return brands.includes( this.vehicle.brand)
        },
        showAlfaHomeChargerOffer() {
            return (this.vehicle.id == 10639 || this.vehicle.id == 10265 || this.vehicle.id == 10637 || this.vehicle.id == 11080 || this.vehicle.id == 11081 || this.vehicle.id == 11082);
        },
        manufacturerName() {
            return GetManufacturerFromBrand(this.vehicle.brand);
        },
        showElectricVehicleGrant() {
            if (this.vehicle.brand == 'citroen') {
                const titreCodes = ['1CSCA5NZFFTXA022','1CSCA5HZFFTXA022','1CSCADHZFFTXAC20','1CSJSUHZFFTXA010','1CSJSUNZFFTXA010','1CLEA5KZIFT0A053','1CLEA5NZIFT0A053','1CLEA5KESFT0A053','1CLEA5HESFT0A053','1CLPA4HESFT0A053','1CLPA4KZIFT0A053','1CLPA4NZIFT0A053','1CLPA4KESFT0A053','1CRESYRFAFTXA010','1CRESYNFAFTXA010','1CRESYHFAFTXA010','1CK9AFVZIFT0A080','1CK9AFSZIFT0A080','1CK9CLSZIFT0A080'];
                if (titreCodes.includes(this.vehicle.titre_code)) {
                    return true;
                }
            }
            if (this.vehicle.brand == 'peugeot') {
                const titreCodes = ['1PP1SYQZIFT0A0G5','1PP1SYUZIFT0A0G5','1PP1SYUZIFT05NG5','1PP2A5QESFT0A0G7','1PP2A5QZIFT0A0G5','1PP2A5UESFT0A0G7','1PP2A5UZIFT0A0G5','1PP2A5UESFT05NG7','1PP2A5UZIFT05NG5','1PP5A5QZIFTXA0E4','1PP5A5UZIFTXA0E4','1PP5C5QZIFTXA0E4','1PP5C5UZIFTXA0E4','1PK9CLTZIFT0A080','1PK9CLTZIFB0A080','1PK9CLWZIFT0A080','1PK9CLWZIFB0A080','1PK9AFTZIFT0A080','1PK9AFWZIFT0A080','1PP6CBQZJFTXA0E4','1PP6CBUZJFTXA0E4'];
                if (titreCodes.includes(this.vehicle.titre_code)) {
                    return true;
                }
            }
            if (this.vehicle.brand == 'vauxhall') {
                const titreCodes = ['1GO5A5LZIFTXBUE2','1GO5A5TZIFTXA0E2','1GO5A5TZIFTX40E2','1GO5C5LZIFTXBUE2','1GO5C5TZIFTXA0E2','1GO5C5TZIFTX40E2','1GO6SYPFCFTXA0B0','1GO6SYUFCFTXA0B4','1GO6SYUFCFTX40B4','1GQOSYKZIFT0BU52','1GQOSYKZIFT0A052','1GQOSYHZIFT0A052','1GQOSYHZIFT04052','1GJOA5TESFT06HH4','1GJOA5TZIFT06HH4','1GJOA5HESFT0A0H4','1GJOA5HZIFT0A0H4','1GJOA5TESFT0A0H4','1GJOA5TZIFT0A0H4','1GJOA5TESFT040H4','1GJOA5TZIFT040H4','1GO3SULZFFTXA0B0','1GO3SULZLFTXA0B0','1GO3SUPZFFTXA0B0','1GO3SUPZLFTXA0B0','1GK9AF8ZIFT0A080','1GK9CL8ZIFT0A080','1GK9AF5ZIFT0A080','1GK9CL5ZIFT0A080'];
                if (titreCodes.includes(this.vehicle.titre_code)) {
                    return true;
                }
            }
            if (this.vehicle.brand == 'vauxhall') {
                const titreCodes = ['1GO5A5LZIFTXBUE2','1GO5A5TZIFTXA0E2','1GO5A5TZIFTX40E2','1GO5C5LZIFTXBUE2','1GO5C5TZIFTXA0E2','1GO5C5TZIFTX40E2','1GO6SYPFCFTXA0B0','1GO6SYUFCFTXA0B4','1GO6SYUFCFTX40B4','1GQOSYKZIFT0BU52','1GQOSYKZIFT0A052','1GQOSYHZIFT0A052','1GQOSYHZIFT04052','1GJOA5TESFT06HH4','1GJOA5TZIFT06HH4','1GJOA5HESFT0A0H4','1GJOA5HZIFT0A0H4','1GJOA5TESFT0A0H4','1GJOA5TZIFT0A0H4','1GJOA5TESFT040H4','1GJOA5TZIFT040H4','1GO3SULZFFTXA0B0','1GO3SULZLFTXA0B0','1GO3SUPZFFTXA0B0','1GO3SUPZLFTXA0B0','1GK9AF8ZIFT0A080','1GK9CL8ZIFT0A080','1GK9AF5ZIFT0A080','1GK9CL5ZIFT0A080'];
                if (titreCodes.includes(this.vehicle.titre_code)) {
                    return true;
                }
            }
            if (this.vehicle.brand == 'alfa-romeo') {
                const capIDs = [105728,105729,105730,107513];
                if (capIDs.includes(this.vehicle.cap_id)) {
                    return true;
                }
            }
            if (this.vehicle.brand == 'fiat') {
                const capIDs = [106904,104003,101137,101138,101139,101153,101154,99132,99133,99134,106831];
                if (capIDs.includes(this.vehicle.cap_id)) {
                    return true;
                }
            }
            if (this.vehicle.brand == 'abarth') {
                const capIDs = [106833,106834,103009,103010,103011,103012,102373,102374];
                if (capIDs.includes(this.vehicle.cap_id)) {
                    return true;
                }
            }
            return false;
        },
    },

    watch: {
        electricSelected: function(electricWasSelected) {
            if (!electricWasSelected) {
                this.showSelectModel = true;
                return;
            }
            if (this.preventElectricSelectedSwitchOnFirstLoad) {
                this.preventElectricSelectedSwitchOnFirstLoad = false;
                return;
            }
            for (let index = 0; index < this.availableOptionsLength; index++) {
                if (this.availableOptions[index].electric) {
                    this.switchToModel(this.availableOptions[index]);
                    return;
                }
            }
        },
        '$route': {
            deep: true,
            immediate: true,
            handler: function (newValue) {
                this.loading = true;
                this.animateIn = false;
                this.$store.commit('Layout/setBrand', this.brand);
                this.$store.dispatch('NewVehicleData/getVehicleData', this.id)
                .then((response) => {

                    this.loading = false;
                    let title = `New ${this.modelTitle} ${this.vehicle.bodystyle} ${this.vehicle.version} | Stellantis &You UK`;
                    if (title.toLocaleLowerCase().substring(0, 7) == 'new new') {
                        title = `${this.modelTitle} ${this.vehicle.bodystyle} ${this.vehicle.version} | Stellantis &You UK`;
                    }
                    document.querySelector('title').innerHTML = title;
                    trackPageView(location.pathname, title);
                    if (response.instant) {
                        this.animateIn = true;
                    }
                    this.showSelectModel = false;
                    this.$store.commit('Layout/setBrand', this.vehicle.brand);
                    if (this.vehicle.fuel_type == 'Electric') {
                        if (this.firstLoad) {
                            this.preventElectricSelectedSwitchOnFirstLoad = true;
                        }
                        this.electricSelected = true;
                    }
                    const spec = Object.keys(this.standardSpec);
                    if (spec.length > 0) {
                        this.standardSpecSelected = spec[0];
                    }

                    if (this.standardSpec || this.techSpecs) {
                        try {
                            this.$nextTick(() => {
                                const specSwiper = new Swiper(this.$refs["specButtons"], {
                                    modules: [Navigation],
                                    grabCursor: true,
                                    slidesPerView: "auto",
                                    spaceBetween: 10,
                                    speed: 400,
                                    direction: "horizontal",
                                    navigation: {
                                        prevEl: this.$refs['swiper-prev'],
                                        nextEl: this.$refs['swiper-next'],
                                    },
                                    on: {
                                        slideChange: () => {
                                            if (specSwiper.isBeginning) {
                                                this.$refs['swiper-prev'].classList.add('new-details__swiper-btn--disabled');
                                                this.$refs['swiper-next'].classList.remove('new-details__swiper-btn--disabled');
                                                return;
                                            }

                                            if (specSwiper.isEnd) {
                                                this.$refs['swiper-prev'].classList.remove('new-details__swiper-btn--disabled');
                                                this.$refs['swiper-next'].classList.add('new-details__swiper-btn--disabled');
                                                return;
                                            }

                                            this.$refs['swiper-prev'].classList.remove('new-details__swiper-btn--disabled');
                                            this.$refs['swiper-next'].classList.remove('new-details__swiper-btn--disabled');
                                        },
                                    }
                                });
                                if (specSwiper.isBeginning) {
                                    if (this.$refs['swiper-prev']) {
                                        this.$refs['swiper-prev'].classList.add('new-details__swiper-btn--disabled');
                                    }
                                    if (this.$refs['swiper-next']) {
                                        this.$refs['swiper-next'].classList.remove('new-details__swiper-btn--disabled');
                                    }
                                    return;
                                } else if (specSwiper.isEnd) {
                                    if (this.$refs['swiper-prev']) {
                                        this.$refs['swiper-prev'].classList.remove('new-details__swiper-btn--disabled');
                                    }
                                    if (this.$refs['swiper-next']) {
                                        this.$refs['swiper-next'].classList.add('new-details__swiper-btn--disabled');
                                    }
                                    return;
                                }
                            });
                        } catch (error) {
                            console.error(error);
                        }
                    }

                    if (this.firstLoad && location.hash == '#finance') {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                this.scrollToFinance();
                            }, 500);
                        });
                    }
                    this.firstLoad = false;
                })
            },
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// resources/assets/js/new-vue/views/new-details.vue